import { DEFAULT_SORTING } from "components/Transactional/Performance/constants"
import { HIDE_ARROW_COLUMN, SHOW_ARROW_COLUMN, TYPE_STRING } from "../constants"

export const validateIsString = (value: any) => {
	return typeof value === TYPE_STRING ? value.toLowerCase() : value
}

export const sortToAscending = (
	firstValue: number | string,
	secondValue: number | string
) => {
	return validateIsString(firstValue) > validateIsString(secondValue)
}

export const sortToDescending = (
	firstValue: number | string,
	secondValue: number | string
) => {
	return validateIsString(firstValue) < validateIsString(secondValue)
}

export const validateShowOrHideArrow = (
	column: string,
	currentColumn: string
) => {
	return column === currentColumn ? SHOW_ARROW_COLUMN : HIDE_ARROW_COLUMN
}

/**
 * TODO: isNecessaryConvert has a predicate function name,
 * 	it does not return a boolean, it parses to integer blindly:
 *  	- perhaps remove this function, it does barely nothing, and name is misleading
 */
export const isNecessaryConvert = (idCol: string, value: any) => {
	return idCol === DEFAULT_SORTING ? parseInt(value) : value
}
